<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-10 px-2 mt-2">
                <a :href="mainModuleUrl" target="_blank">
                    <img :src="require(`@/assets/logo-${tenant}-icon.svg`)" class="brand-img mr-1" />
                    <img :src="require(`@/assets/logo-${tenant}-text.svg`)" class="brand-img"
                /></a>
            </div>
            <div class="col-2 text-right mt-3">
                <a :href="mainModuleUrl" class="btn-back-to-dashboard btn btn-sm"
                    style="color: #fff; border: 1px solid #fff;">{{ this.$i18n.BACK_TO_DASHBOARD }}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            mainModuleUrl: process.env.VUE_APP_MAIN_MODULE_URL,
            tenant: process.env.VUE_APP_ASSETS
        };
    }
};
</script>

<style scoped>
.nav-bar-btn {
    color: rgb(220, 220, 220);
    width: 100%;
    height: auto;
}

.nav-bar-btn:hover {
    color: rgba(255, 255, 255);
}

.btn-back-to-dashboard:hover {
    background-color: rgb(255, 255, 255, 0.2);
}

.brand-img {
    height: 3.4rem;
}
</style>
